import React from 'react';
import { UsersIcon, FileTextIcon, ActivityIcon, AlertTriangleIcon, ListChecksIcon } from 'lucide-react';
import { TeamMember } from '../types';
interface StatCardsProps {
  members: TeamMember[];
}
export function StatCards({
  members
}: StatCardsProps) {
  const totalMembers = members.length;
  const activeMembers = members.filter(m => m.isActive).length;
  const totalActiveFiles = members.reduce((sum, m) => sum + m.workload.activeFiles, 0);
  const totalRules = members.reduce((sum, m) => sum + m.rules.length, 0);
  const activeRules = members.reduce((sum, m) => sum + m.rules.filter(r => r.isActive).length, 0);
  const membersAtCapacity = members.filter(m => m.workload.activeFiles >= m.workload.capacity).length;
  const totalCapacity = members.reduce((sum, m) => sum + m.workload.capacity, 0);
  const utilizationPct = totalCapacity > 0 ? Math.round(totalActiveFiles / totalCapacity * 100) : 0;
  return <div className="bg-white border-b border-gray-200 px-4 sm:px-6 lg:px-8 py-2.5 flex flex-wrap items-center gap-x-8 gap-y-2 text-sm" data-id="element-186">
      <div className="flex items-center space-x-2" data-id="element-187">
        <UsersIcon className="h-4 w-4 text-blue-500" data-id="element-188" />
        <span className="text-[10px] font-semibold text-gray-500 uppercase tracking-wider" data-id="element-189">
          Active Agents
        </span>
        <span className="font-bold text-gray-900" data-id="element-190">
          {activeMembers}
          <span className="text-gray-400 font-normal" data-id="element-191">/{totalMembers}</span>
        </span>
      </div>

      <div className="hidden sm:block h-4 w-px bg-gray-200" data-id="element-192" />

      <div className="flex items-center space-x-2" data-id="element-193">
        <ListChecksIcon className="h-4 w-4 text-indigo-500" data-id="element-194" />
        <span className="text-[10px] font-semibold text-gray-500 uppercase tracking-wider" data-id="element-195">
          Active Rules
        </span>
        <span className="font-bold text-gray-900" data-id="element-196">
          {activeRules}
          <span className="text-gray-400 font-normal" data-id="element-197">/{totalRules}</span>
        </span>
      </div>

      <div className="hidden sm:block h-4 w-px bg-gray-200" data-id="element-198" />

      <div className="flex items-center space-x-2" data-id="element-199">
        <FileTextIcon className="h-4 w-4 text-violet-500" data-id="element-200" />
        <span className="text-[10px] font-semibold text-gray-500 uppercase tracking-wider" data-id="element-201">
          Pipeline
        </span>
        <span className="font-bold text-gray-900" data-id="element-202">
          {totalActiveFiles}{' '}
          <span className="text-gray-400 font-normal text-xs" data-id="element-203">files</span>
        </span>
      </div>

      <div className="hidden sm:block h-4 w-px bg-gray-200" data-id="element-204" />

      <div className="flex items-center space-x-2" data-id="element-205">
        <ActivityIcon className="h-4 w-4 text-green-500" data-id="element-206" />
        <span className="text-[10px] font-semibold text-gray-500 uppercase tracking-wider" data-id="element-207">
          Utilization
        </span>
        <span className="font-bold text-gray-900" data-id="element-208">{utilizationPct}%</span>
      </div>

      <div className="hidden sm:block h-4 w-px bg-gray-200" data-id="element-209" />

      <div className="flex items-center space-x-2" data-id="element-210">
        <AlertTriangleIcon className={`h-4 w-4 ${membersAtCapacity > 0 ? 'text-amber-500' : 'text-gray-400'}`} data-id="element-211" />
        <span className="text-[10px] font-semibold text-gray-500 uppercase tracking-wider" data-id="element-212">
          At Capacity
        </span>
        <span className={`font-bold ${membersAtCapacity > 0 ? 'text-amber-600' : 'text-gray-900'}`} data-id="element-213">
          {membersAtCapacity}
        </span>
      </div>
    </div>;
}